module.exports = __webpack_public_path__ + "img/bayern-logo.a881a3b3.png";